
import React, { useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import {
  useCurrencyStore,
  SUPPORTED_CURRENCIES,
} from "../store/currencyStore";



type CurrencySelectorProps = {
  compact?: boolean;
  className?: string;
};

export default function CurrencySelector({
  compact = false,
  className = "",
}: CurrencySelectorProps) {
  const { selectedCurrency, setCurrency } = useCurrencyStore();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);


  const selectedCurrencyInfo = SUPPORTED_CURRENCIES.find(
    (c) => c.code === selectedCurrency,
  );

  const displayLabel =
    selectedCurrency === "MultiDevices"
      ? compact
        ? "Multi"
        : selectedCurrencyInfo?.name || "Multi Device Currency"
      : selectedCurrencyInfo?.code || selectedCurrency;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {

        setIsOpen(false);
      }
    };

    if (isOpen) {

      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);

    };
  }, [isOpen]);

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-1 rounded-md border border-gray-300 bg-white font-medium transition-colors hover:bg-gray-50 ${
          compact ? "px-2 py-1.5 text-xs" : "px-3 py-1.5 text-sm"
        }`}
        aria-label="Select currency"
      >
        <span className="max-w-[5rem] truncate sm:max-w-none">{displayLabel}</span>
        <ChevronDownIcon
          className={`h-4 w-4 shrink-0 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-2 w-56 max-w-[min(14rem,calc(100vw-1rem))] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg">
          <div className="max-h-64 overflow-y-auto py-1">
            {SUPPORTED_CURRENCIES.map((currency) => (
              <button
                key={currency.code}
                type="button"
                onClick={() => {
                  setCurrency(currency.code);
                  setIsOpen(false);
                }}
                className={`w-full px-4 py-2 text-left text-sm transition-colors hover:bg-gray-100 ${
                  selectedCurrency === currency.code
                    ? "bg-blue-50 font-medium text-blue-700"
                    : "text-gray-700"
                }`}
              >
                {currency.code === "MultiDevices" ? (
                  <span className="whitespace-nowrap">{currency.name}</span>
                ) : (
                  <div className="flex items-center justify-between gap-2 whitespace-nowrap">
                    <span>{currency.code}</span>
                    <span className="max-w-[110px] truncate text-right text-xs text-gray-500">
                      {currency.name}
                    </span>
                  </div>
                )}

              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

